import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { usePurchaseOrderActivities } from '@/hooks/api/0670_purchase_order_activities';
import { ActivityRow } from '@/components/features/ActivityRow';
import { MotionDiv } from '@/components/element/MotionDiv';

export const Activities = () => {
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { data: activities } = usePurchaseOrderActivities({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    id: _po_!.id,
  });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">プロジェクトの変更履歴</h6>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="timeline timeline-one-side" data-timeline-axis-style="dotted">
          {activities?.map((d) => <ActivityRow key={`activity-${d.id}`} d={d} />)}
        </div>
      </div>
    </MotionDiv>
  );
};
